import { Link } from 'react-router-dom';

import { MockPanel } from '../chrome/marks';
import { DEMO_PATHS } from '../paths';

/**
 * Setup (step 23) — what of Setup is still the demo's, each a panel inside a live screen: the
 * in-consideration thresholds inside the concern criteria (`/team/setup/criteria`, SR-222). Who may
 * do what is survey-api's since SR-228 (Team Portal roles).
 */

/* ------------------------------------------------------------------------------------------------
 * In-consideration thresholds — a mock panel inside the live criteria screen
 * ---------------------------------------------------------------------------------------------- */

/**
 * The thresholds half of what was "Criteria & thresholds": the concern criteria are survey-api's
 * since SR-222 (`/team/setup/criteria`), and the thresholds that put a record in consideration have
 * no route, so they stay the demo's — a badged panel after the live criteria, drawn through
 * `CriteriaThresholdsSlot`, never restyled to pass as live.
 */
export function CriteriaThresholdsPanel() {
  return (
    <MockPanel
      title="In-consideration thresholds"
      source="no-endpoint"
      description={
        'The AUM and production thresholds that put a record in consideration — a boolean ' +
        'formula the survey owner sets before the survey opens (PRS §5 and §6.1). They have no ' +
        'route yet.'
      }
    >
      <p className="text-[0.8125rem]">
        They are set on{' '}
        <Link
          to={DEMO_PATHS.initialReview}
          className="font-medium text-[var(--color-sapphire)] underline-offset-4 hover:underline"
        >
          Initial review
        </Link>
        , where the records a change lets in or leaves out are seen as it is made.
      </p>
    </MockPanel>
  );
}
